import angular, { IPromise, Injectable } from "angular";
import { MenuItem } from "./MenuItem";
import { vsName as menuServiceName, MenuService } from "./MenuService";

export const vsName: string = menuServiceName;
export const vsProviderName: string = `${vsName}Provider`;

interface runScript {
  ($injector: angular.auto.IInjectorService): IPromise<boolean>;
}

export class MenuProvider implements angular.IServiceProvider {
  readonly menuItems: MenuItem[] = [];

  private readonly runScripts: runScript[] = [];

  addMenuItem(item: MenuItem, order?: number) {
    const insertAt = order ?? this.menuItems.length;
    this.menuItems.splice(insertAt, 0, item);
  }

  addConditionalMenuItem(
    item: MenuItem,
    condition: Injectable<(...args: any[]) => IPromise<boolean>>,
    order?: number
  ) {
    item.preConditionMet = false;
    this.runScripts.push(($injector: angular.auto.IInjectorService) =>
      $injector
        .invoke(condition)
        .then((preConditionMet) => (item.preConditionMet = preConditionMet))
    );
    this.addMenuItem(item, order);
  }

  findMenuItem(id: string): MenuItem | null {
    return (
      this.menuItems.find((mi) => this.findMenuItemRecursively(id, mi)) ?? null
    );
  }

  private findMenuItemRecursively(
    id: string,
    menuItem: MenuItem
  ): MenuItem | null {
    if (menuItem.getId() === id) {
      return menuItem;
    }

    menuItem.getChildren().forEach((mi) => {
      const menuItem = this.findMenuItemRecursively(id, mi);
      if (menuItem) {
        return menuItem;
      }
    });

    return null;
  }

  readonly $get = [
    "$injector",
    ($injector: angular.auto.IInjectorService): MenuService => {
      const menuItems = this.menuItems;

      this.runScripts.forEach((rs) => rs($injector));

      return new MenuService(menuItems);
    },
  ];
}
